import script from "./DuaIhram.vue?vue&type=script&setup=true&lang=js"
export * from "./DuaIhram.vue?vue&type=script&setup=true&lang=js"

import "./DuaIhram.vue?vue&type=style&index=0&id=279986bd&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-279986bd"]])

export default __exports__